/**
 * Copyright © 2018 Galaxy Software Services https://github.com/GSS-FED/vital-ui-kit-react
 * MIT license
 */
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import styled from 'styled-components';
import { Select } from './Select';
import { Context } from './context';
import { fieldWrapperBase, fieldInputBase, } from '../components/FieldBase';
import { defaultTheme } from '@vital-ui/react-theme';
var InputBase = styled.input(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  border: 0;\n  outline: 0;\n  height: 1.93267rem;\n  width: 100px;\n  border-radius: inherit;\n"], ["\n  ", ";\n  border: 0;\n  outline: 0;\n  height: 1.93267rem;\n  width: 100px;\n  border-radius: inherit;\n"])), fieldInputBase);
InputBase.defaultProps = {
    theme: defaultTheme,
};
var InputWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  display: flex;\n  flex-wrap: wrap;\n  cursor: pointer;\n  overflow: hidden;\n"], ["\n  ", ";\n  display: flex;\n  flex-wrap: wrap;\n  cursor: pointer;\n  overflow: hidden;\n"])), fieldWrapperBase);
InputWrapper.defaultProps = {
    theme: defaultTheme,
};
var Input = React.forwardRef(function (props, ref) { return (React.createElement(Context.Consumer, null, function (_a) {
    var getInputProps = _a.getInputProps;
    return (React.createElement(InputBase
    // @ts-ignore
    , __assign({ 
        // @ts-ignore
        ref: ref }, getInputProps(__assign({}, props)))));
})); });
var MultiSelect = /** @class */ (function (_super) {
    __extends(MultiSelect, _super);
    function MultiSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            input: '',
            isOpen: false,
        };
        _this.input = React.createRef();
        // -------------------------------------
        //   Event Handlers
        // -------------------------------------
        _this.handleChange = function (item) {
            if (_this.props.onChange) {
                _this.props.onChange(_this.props.values.concat([item]));
            }
            _this.setState({ input: '', isOpen: false });
        };
        _this.handleInputClick = function () {
            if (_this.input.current) {
                _this.input.current.focus();
            }
            _this.setState({
                isOpen: true,
            });
        };
        _this.handleOuterClick = function () {
            _this.setState({
                isOpen: false,
            });
        };
        _this.handleInputChange = function (evt) {
            _this.setState({ input: evt.target.value, isOpen: true });
        };
        _this.handleKeyDown = function (evt) {
            var values = _this.props.values;
            if (values.length &&
                !_this.state.input.length &&
                evt.keyCode === 8 &&
                _this.props.onChange) {
                _this.props.onChange(values.slice(0, values.length - 1));
            }
        };
        return _this;
    }
    MultiSelect.prototype.render = function () {
        var _a = this.props, children = _a.children, selection = _a.selection, values = _a.values, props = __rest(_a, ["children", "selection", "values"]);
        return (React.createElement(Select, __assign({ inputValue: this.state.input, 
            // @ts-ignore
            selectedItem: values, onOuterClick: this.handleOuterClick, isOpen: this.state.isOpen }, props, { 
            // @ts-ignore
            onChange: this.handleChange }), React.cloneElement(React.Children.only(children), {}, React.createElement(InputWrapper, { onClick: this.handleInputClick },
            selection && selection,
            React.createElement(Input, { ref: this.input, onChange: this.handleInputChange, onKeyDown: this.handleKeyDown })))));
    };
    MultiSelect.Dropdown = Select.Dropdown;
    MultiSelect.DropdownItem = Select.DropdownItem;
    MultiSelect.Input = Input;
    MultiSelect.Context = Context;
    return MultiSelect;
}(React.Component));
export { MultiSelect };
var templateObject_1, templateObject_2;
//# sourceMappingURL=MultiSelect.js.map